import styled from '@emotion/styled'
import DropdownToggle from 'react-bootstrap/DropdownToggle'
import DropdownItem from 'react-bootstrap/esm/DropdownItem'
import DropdownMenu from 'react-bootstrap/DropdownMenu'
import { ReactComponent as Bell } from '../../assets/svgs/bell.svg'

// In dropdown.jsx, update both components:
export const DropdownToggleBtn = styled(DropdownToggle)(
  ({
    backgroundColor = 'transparent !important',
    color = null,
    borderRadius = '0px',
    fontWeight = 500,
    theme,
  }) => ({
    padding: '0',
    height: '40px',
    boxShadow: 'none !important',
    color: color || theme.headerItemColor,
    fontWeight,
    backgroundColor,
    border: '0',
    borderRadius,
    position: 'relative',
    '&:hover': {
      color: color || theme.headerItemColor,
      backgroundColor,
    },
    '&:focus': {
      backgroundColor,
      color: color || theme.headerItemColor,
    },
    '&:active': {
      color: theme.headerItemColor + ' !important',
      backgroundColor: backgroundColor + ' !important',
    },
    '& p, & div': {
      color: theme.headerItemColor + ' !important',
    },
    '& svg path': {
      fill: theme.headerItemColor + ' !important',
    },
    '&::after': {
      color: color || theme.headerItemColor + ' !important',
    },
  }),
)

export const NotificationBtn = styled(Bell)(({ theme }) => ({
  background: 'transparent',
  color: theme.headerItemColor,
  fontSize: '1.5rem',
  cursor: 'pointer',
  '&:hover': {
    color: theme.headerItemColorHover,
  },
}))

export const NotificationBadge = styled('span')(
  ({
    backgroundColor = 'red',
    position = 'absolute',
    width = '18px',
    fontSize = '0.6875rem',
    top = '15px',
    right = '5px',
  }) => ({
    position,
    top,
    right,
    color: 'white',
    width,
    height: width,
    fontSize,
    backgroundColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
)

export const StyledDropdownMenu = styled(DropdownMenu)(({ width, theme }) => ({
  margin: '0',
  padding: '2px',
  border: '1px solid #E0E0E0',
  listStyle: 'none',
  width,
  backgroundColor: theme.white,
  zIndex: '9999',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
  transform: 'translateY(90px)',
  maxHeight: '350px !important',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    width: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#E0E0E0',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.white,
  },
}))

export const NotificationItemText = styled('div')(({ backgroundColor }) => ({
  padding: '0.75rem 1rem',
  height: 'fit-content',
  backgroundColor,
  '&:hover': {
    backgroundColor: '#c4c7d1',
  },
}))

export const ActiveDropdownItem = styled(DropdownItem)({
  backgroundColor: '#c4c7d1',
  '& p, & div': {
    color: '#2c3e50',
  },
  '& svg path': {
    fill: '#2c3e50',
  },
  '&:hover': {
    backgroundColor: '#b3b6c2',
  },
  '&:active': {
    backgroundColor: '#5c6ac4',
    '& p, & div': {
      color: '#ffffff',
    },
    '& svg path': {
      fill: '#ffffff',
    },
  },
  '&:focus': {
    backgroundColor: '#c4c7d1',
  },
})

export const CompanyLogo = styled('img')({
  width: '30px',
  height: '30px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '999px',
  objectFit: 'cover',
  objectPosition: 'center',
})

export const VerticalScroll = styled('div')(({ maxHeight = '250px' }) => ({
  display: 'grid',
  gridAutoFlow: 'row',
  overflowY: 'auto',
  overscrollBehaviorInline: 'contain',
  maxHeight,
}))

export const SubscriptionCounterBadge = styled(NotificationBadge)(
  ({
    width = '25px',
    top = '-10px',
    right = '-10px',
    isWrapText = false,
    hoverText,
    displayCount,
    theme,
  }) => ({
    top,
    right,
    fontSize: '0.85rem',
    backgroundColor: theme.hintsNotifications,
    marginBottom: '2rem',
    width,
    height: width,
    '&:hover::before': {
      content: `"${hoverText}"`,
      position: 'absolute',
      top: '-110%',
      left: isWrapText ? '10%' : '50%',
      transform: 'translateX(-50%)',
      padding: '0.5rem',
      backgroundColor: theme.hintsNotifications,
      color: theme.textPrimary,
      fontSize: '0.8rem',
      borderRadius: '0.25rem',
      zIndex: 1,
      whiteSpace: isWrapText ? 'normal' : 'nowrap',
      maxWidth: isWrapText ? '79px' : 'auto',
      display: displayCount ? 'none' : 'block',
    },

    '&:hover': {
      '&::before': {
        display: displayCount ? 'none' : 'block',
      },
    },
  }),
)

export const EllipsisCompanyName = styled('div')({
  maxWidth: '180px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: 'inherit',
})
